/**
 * Bring an element into view inside the pane that scrolls it -- and only that
 * pane, where element.scrollIntoView() would move the page as well. Something
 * already in view is left where it is.
 *
 * @param {HTMLElement} scroller
 * @param {HTMLElement} el
 * @param {number} topInset  how much of the scroller's top is covered by
 *   something stuck there (a table's header row, a pinned sidebar row)
 */
const revealInScroller = (scroller, el, topInset = 0) => {

  if (!scroller || !el) {
    return;
  }

  const box = scroller.getBoundingClientRect();
  const elBox = el.getBoundingClientRect();

  const top = box.top + topInset;
  const bottom = box.top + scroller.clientHeight;

  if (elBox.top < top) {
    scroller.scrollTop -= top - elBox.top;
  } else if (elBox.bottom > bottom) {
    scroller.scrollTop += elBox.bottom - bottom;
  }

};

export default revealInScroller;
